/** Shared registration only. Publication still requires the authored record. */
export const HELP_ARTICLE_ROUTE = "/help/article/:slug";
export const helpArticlePath = slug => `/help/article/${slug}`;
export function matchHelpArticlePath(pathname) {
  const match = /^\/help\/article\/([^/]+)\/?$/.exec(pathname);
  return match ? { slug: match[1] } : null;
}

/** Registration shared by the HTTP reader and browser body selection.
 * Slug existence is intentionally decided by the primary authoring readers.
 * @returns {null | {type: "help-index" | "help-contact" | "help-search" | "guide-index"} |
 * {type: "help-article" | "help-topic" | "guide-category" | "guide-article", slug: string}} */
export function matchPublicKnowledgePath(pathname) {
  const article = matchHelpArticlePath(pathname);
  if (article) return { type: "help-article", ...article };
  const path = pathname.replace(/\/$/, "");
  if (path === "/help") return { type: "help-index" };
  if (path === "/help/contact") return { type: "help-contact" };
  if (path === "/help/search") return { type: "help-search" };
  const topic = /^\/help\/topic\/([^/]+)$/.exec(path);
  if (topic) return { type: "help-topic", slug: topic[1] };
  if (path === "/guides") return { type: "guide-index" };
  const category = /^\/guides\/category\/([^/]+)$/.exec(path);
  if (category) return { type: "guide-category", slug: category[1] };
  const guide = /^\/guides\/([^/]+)$/.exec(path);
  return guide ? { type: "guide-article", slug: guide[1] } : null;
}
